var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTaiwan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.4297C32 25.2662 24.8365 32.4297 16 32.4297C7.1635 32.4297 0 25.2662 0 16.4297C5.49563 10.9341 10.1565 6.27319 16 0.429688C24.8365 0.429688 32 7.59319 32 16.4297Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.4297C16 7.59319 16 6.55144 16 0.429688C7.1635 0.429688 0 7.59319 0 16.4297H16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9131 9.79327L11.959 10.7125L12.9995 12.605L10.8777 12.199L10.6088 14.3425L9.13088 12.766L7.65288 14.3425L7.38407 12.199L5.26219 12.6048L6.30269 10.7124L4.34869 9.79327L6.30276 8.8742L5.26219 6.9817L7.38401 7.38764L7.65294 5.24414L9.13088 6.82064L10.6088 5.24414L10.8777 7.38764L12.9996 6.9817L11.959 8.87427L13.9131 9.79327Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13066 12.7716C10.7755 12.7716 12.109 11.4381 12.109 9.79325C12.109 8.14838 10.7755 6.81494 9.13066 6.81494C7.48578 6.81494 6.15234 8.14838 6.15234 9.79325C6.15234 11.4381 7.48578 12.7716 9.13066 12.7716Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13088 11.3805C8.25582 11.3805 7.54395 10.6686 7.54395 9.79354C7.54395 8.91848 8.25588 8.20654 9.13088 8.20654C10.0059 8.20654 10.7179 8.91848 10.7179 9.79354C10.7178 10.6686 10.0058 11.3805 9.13088 11.3805Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.429688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTaiwan);
export default __webpack_public_path__ + "static/media/flag_taiwan.48784f3dc05b6758cffad05de8f027da.svg";
export { ForwardRef as ReactComponent };